import { Pinia, Store } from 'pinia-class-component';
import { initClient } from '../../api';
import { PlaceOfUseType, TestEquipmentPlaceOfUseAPIControllerUIClient } from '../../components/backend/backendapi';

@Store({
  id: 'PlaceOfUseTypeStore',
  name: 'PlaceOfUseTypeStore',
})
export default class PlaceOfUseTypeStore extends Pinia {
  private readonly api = initClient(TestEquipmentPlaceOfUseAPIControllerUIClient);

  //data
  private _loadingPromise: Promise<PlaceOfUseType[]> | null = null;
  private _placeOfUseTypes: PlaceOfUseType[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get placeOfUseTypes(): PlaceOfUseType[] {
    return this._placeOfUseTypes;
  }

  get placeOfUseTypesById(): Map<number, PlaceOfUseType> {
    return new Map(this._placeOfUseTypes.map(e => [e.id, e]));
  }

  //actions
  clear(): void {
    this._placeOfUseTypes.splice(0);
  }

  setPlaceOfUseTypes(placeOfUseTypes: PlaceOfUseType[]): void {
    this._placeOfUseTypes.splice(0);
    this._placeOfUseTypes.push(...placeOfUseTypes);
  }

  rememberPlaceOfUseType(placeOfUseType: PlaceOfUseType): void {
    const index = this._placeOfUseTypes.findIndex(e => e.id === placeOfUseType.id);
    if (index >= 0) {
      this._placeOfUseTypes.splice(index, 1, placeOfUseType);
    } else {
      this._placeOfUseTypes.push(placeOfUseType);
    }
  }

  forgetPlaceOfUseType(placeOfUseType: PlaceOfUseType): void {
    const index = this._placeOfUseTypes.findIndex(e => e.id === placeOfUseType.id);
    if (index >= 0) {
      this._placeOfUseTypes.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.api.list();
      const placeOfUseTypes = await this._loadingPromise;
      this.setPlaceOfUseTypes(placeOfUseTypes ?? []);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._placeOfUseTypes.length > 0) {
      return;
    }
    return await this.reload();
  }
}